import { render, staticRenderFns } from "./TcfdDataTable.vue?vue&type=template&id=a1edc138"
import script from "./TcfdDataTable.vue?vue&type=script&lang=js"
export * from "./TcfdDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports